import styled from "styled-components";
import {baseDistance, ELLIPSIS, FLEXCENTER, fontSize, radius} from "../../styles/styles";
import {colorPalette} from "../../styles/colorPalette";
import {SelectInputStyled} from "../../input/select/SelectInputV5";
import {TextInputStyled} from "../../details/datatypes/TextInputV5";

export const AdvancedFilterFieldStyled = styled.div`
	.criterias {
		flex: 1;

		${SelectInputStyled} {
			background-color: ${colorPalette.white};
			border: none;
		}

		${TextInputStyled} {
			border: none;
			${ELLIPSIS};
		}

		.header {
			width: 64px;
			height: 24px;
			${FLEXCENTER};
			background-color: ${colorPalette.gray.c300};
			border-radius: ${radius.sm};
			font-size: ${fontSize.sm};
		}

		input {
			width: 100%;
			padding: ${baseDistance.sm};
			border-radius: ${radius.sm};
			background: ${colorPalette.white};
		}

		span.delete {
			svg.icon {
				width: 10px;
				height: 10px;
			}
		}
	}

	.deleteColumn {
		align-items: center;
		display: flex;
		padding: 10px;

		span.delete {
			svg.icon {
				top: 0px;
				width: 12px;
				height: 12px;
			}
		}
	}
`;
